import { TranslatableField } from "../utils/translations";

/**
 * Which fields of each entity the backend accepts translations for.
 *
 * Single source of truth shared by the slices (which prune blank translation
 * rows before sending) and the pages (which render the locale tabs and the
 * translation-coverage column), so the two can never drift apart.
 *
 * Mirrors `ActivityTranslationDto`, `MeasurementTypeTranslationDto`,
 * `MeasurementValueTypeTranslationDto` and `TreatmentTemplateTranslationDto` in
 * the generated client. Note that `MeasurementValueTypeDto.uoM` is deliberately
 * absent: units of measurement are not localized by the API, and neither is a
 * treatment template's image.
 */

export type ActivityFieldKey = "name";

export const activityFields: ReadonlyArray<TranslatableField<ActivityFieldKey>> = [
    { key: "name", labelKey: "localizedFields.field.name", placeholderKey: "placeholder.activityName" }
];

export const activityFieldKeys: ReadonlyArray<ActivityFieldKey> = activityFields.map(
    field => field.key
);

export type MeasurementTypeFieldKey = "description" | "measurementProcedure";

export const measurementTypeFields: ReadonlyArray<TranslatableField<MeasurementTypeFieldKey>> = [
    { key: "description", labelKey: "localizedFields.field.description", placeholderKey: "placeholder.measurementDescription" },
    { key: "measurementProcedure", labelKey: "localizedFields.field.procedure", type: "textarea", rows: 4 }
];

export const measurementTypeFieldKeys: ReadonlyArray<MeasurementTypeFieldKey> =
    measurementTypeFields.map(field => field.key);

export type MeasurementValueTypeFieldKey = "description";

export const measurementValueTypeFields: ReadonlyArray<
    TranslatableField<MeasurementValueTypeFieldKey>
> = [{ key: "description", labelKey: "localizedFields.field.description" }];

export const measurementValueTypeFieldKeys: ReadonlyArray<MeasurementValueTypeFieldKey> =
    measurementValueTypeFields.map(field => field.key);

export type TreatmentTemplateFieldKey = "name" | "instructions";

export const treatmentTemplateFields: ReadonlyArray<TranslatableField<TreatmentTemplateFieldKey>> = [
    { key: "name", labelKey: "localizedFields.field.name" },
    { key: "instructions", labelKey: "localizedFields.field.instructions", type: "textarea", rows: 8 }
];

export const treatmentTemplateFieldKeys: ReadonlyArray<TreatmentTemplateFieldKey> =
    treatmentTemplateFields.map(field => field.key);
